module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseDateTime', _vm.className]
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "BaseDateTime__date"
  }, [_c('i', {
    staticClass: "BaseDateTime__icon icon-calendar",
    on: {
      "click": function($event) {
        _vm.open({
          dateString: _vm.dateString,
          title: _vm.title,
          handlerAction: _vm.handlerAction,
          handlerActionParams: _vm.handlerActionParams,
          showTime: _vm.showTime
        })
      }
    }
  }), _vm._v(" "), _c('BaseText', {
    attrs: {
      "value": _vm.dateString,
      "errors": _vm.errors,
      "class-name": 'BaseDateTime__text'
    },
    on: {
      "change": _vm.change
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "BaseDateTime__label"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b873ba2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseDateTime.vue
// module id = 554
// module chunks = 1